"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var url_and_query_params_1 = require("../../../../shared/utils/url-and-query-params");
function navigateToForm(navigationPrefix, rootCategoryId, rootEntityId, categoryId, entityId, formName, formId, route, router, params) {
    var url = navigationPrefix + "/" + rootCategoryId + "/" + rootEntityId + "/dynamic-de/" + categoryId + "/" + formName + "/" + formId + "/" + entityId;
    var queryParams = cleanupQueryParams(route.snapshot.queryParams, params);
    return Observable_1.Observable.fromPromise(router.navigate([url], { queryParams: queryParams }));
}
exports.navigateToForm = navigateToForm;
function navigateToOverviewForm(navigationPrefix, rootCategoryId, rootEntityId, formId, route, router, params) {
    var url = navigationPrefix + "/" + rootCategoryId + "/" + rootEntityId + "/dynamic-de/" + rootCategoryId + "/" + rootCategoryId + "Overview/" + formId + "/" + rootEntityId;
    var queryParams = cleanupQueryParams(route.snapshot.queryParams, params);
    return Observable_1.Observable.fromPromise(router.navigate([url], { queryParams: queryParams }));
}
exports.navigateToOverviewForm = navigateToOverviewForm;
function navigateToCreateForm(navigationPrefix, rootCategoryId, rootEntityId, categoryId, formName, formId, route, router, params) {
    var url = rootEntityId && rootCategoryId !== categoryId
        ? navigationPrefix + "/" + rootCategoryId + "/" + rootEntityId + "/dynamic-de/" + categoryId + "/" + formName + "/" + formId
        : navigationPrefix + "/" + rootCategoryId + "/dynamic-de/" + categoryId + "/" + formName + "/" + formId;
    var queryParams = cleanupQueryParams(route.snapshot.queryParams, params);
    return Observable_1.Observable.fromPromise(router.navigate([url], { queryParams: queryParams }));
}
exports.navigateToCreateForm = navigateToCreateForm;
function navigateToPortfolio(navigationPrefix, rootCategoryId, rootEntityId, categoryId, route, router, params) {
    var url = navigationPrefix + "/" + rootCategoryId + "/" + rootEntityId + "/" + categoryId;
    var queryParams = cleanupQueryParams(route.snapshot.queryParams, params, ['state']);
    return Observable_1.Observable.fromPromise(router.navigate([url], { queryParams: queryParams }));
}
exports.navigateToPortfolio = navigateToPortfolio;
function navigateToRootPortfolio(navigationPrefix, rootCategoryId, route, router, params) {
    var url = navigationPrefix + "/" + rootCategoryId;
    var queryParams = cleanupQueryParams(route.snapshot.queryParams, params, ['state']);
    return Observable_1.Observable.fromPromise(router.navigate([url], { queryParams: queryParams }));
}
exports.navigateToRootPortfolio = navigateToRootPortfolio;
function navigateToCustomLocation(navigationPrefix, customUrl, rootCategoryId, rootEntityId, route, router, params) {
    var url = navigationPrefix + "/" + rootCategoryId + "/" + rootEntityId + "/custom/" + customUrl;
    var queryParams = cleanupQueryParams(route.snapshot.queryParams, params);
    return Observable_1.Observable.fromPromise(router.navigate([url], { queryParams: queryParams }));
}
exports.navigateToCustomLocation = navigateToCustomLocation;
function getPropertyFromUrl(key, route) {
    var urlVariable = route.snapshot.paramMap.get(key);
    var param = route.snapshot.queryParams[key];
    if (urlVariable) {
        return urlVariable;
    }
    else if (param) {
        return param;
    }
    return null;
}
exports.getPropertyFromUrl = getPropertyFromUrl;
function getNumericPropertyFromUrl(key, route) {
    var urlVariable = route.snapshot.paramMap.get(key);
    var param = route.snapshot.queryParams[key];
    if (urlVariable) {
        return +urlVariable;
    }
    else if (param) {
        return +param;
    }
    return null;
}
exports.getNumericPropertyFromUrl = getNumericPropertyFromUrl;
function cleanupQueryParams(existingQueryParams, paramsToAdd, paramsToDelete) {
    var queryParams = Object.assign({}, existingQueryParams);
    delete queryParams[url_and_query_params_1.UrlAndQueryParams.typeId];
    delete queryParams[url_and_query_params_1.UrlAndQueryParams.subTypeId];
    delete queryParams[url_and_query_params_1.UrlAndQueryParams.rootEntityId];
    delete queryParams[url_and_query_params_1.UrlAndQueryParams.isAutofill];
    delete queryParams[url_and_query_params_1.UrlAndQueryParams.duplicateEntityId];
    if (paramsToDelete) {
        paramsToDelete.forEach(function (key) { return delete queryParams[key]; });
    }
    if (paramsToAdd) {
        paramsToAdd.forEach(function (value, key) { return !!value && (queryParams[key] = value); });
    }
    return queryParams;
}
exports.cleanupQueryParams = cleanupQueryParams;
//# sourceMappingURL=dynamic-navigation-helper.js.map